export const CUSTOMIZATION_ROUTE_PREFIX = '/customization';
export const CUSTOMIZATION_ROUTE = `${CUSTOMIZATION_ROUTE_PREFIX}/[id]/[step]/[options]`;

export const CUSTOMIZATION_KEY_PREFIX = 'customization';

export const CUSTOMIZATION_RETURN_URL = {
  CHECKOUT: 'checkout',
  HOME: 'home'
};

export const CUSTOMIZATION_NAMES = {
  TEXT: 'text',
  ORIENTATION: 'orientation',
  SIZE: 'size',
  SIGNATURE: 'signature',
  REVIEW: 'review',
  REPORT: 'report'
};

export const CUSTOMIZATION_MODES = {
  PREVIEW: 'preview',
  EDIT: 'edit',
  POSITION: 'position'
};

export const CUSTOMIZATION_STEPS = [{
  id: 0,
  url: CUSTOMIZATION_NAMES.TEXT,
  tKey: CUSTOMIZATION_NAMES.TEXT,
  showStep: true
}, {
  id: 1,
  url: CUSTOMIZATION_NAMES.ORIENTATION,
  tKey: CUSTOMIZATION_NAMES.ORIENTATION,
  showStep: true
}, {
  id: 2,
  url: CUSTOMIZATION_NAMES.SIZE,
  tKey: CUSTOMIZATION_NAMES.SIZE,
  showStep: true
}, {
  id: 3,
  url: CUSTOMIZATION_NAMES.SIGNATURE,
  tKey: CUSTOMIZATION_NAMES.SIGNATURE,
  showStep: true
}, {
  id: 4,
  url: CUSTOMIZATION_NAMES.REVIEW,
  tKey: CUSTOMIZATION_NAMES.REVIEW,
  hideStep: true
}, {
  id: 5,
  url: CUSTOMIZATION_NAMES.REPORT,
  tKey: CUSTOMIZATION_NAMES.REPORT,
  hideStep: true,
  readOnly: true
}];

export const CUSTOMIZATION_ORIENTATIONS = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};

export const CUSTOMIZATION_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

export const CUSTOMIZATION_POSITIONS = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};

export const CUSTOMIZATION_INIT = {
  text: '',
  orientation: CUSTOMIZATION_ORIENTATIONS.VERTICAL,
  size: CUSTOMIZATION_SIZES.SMALL,
  signature: '',
  position: CUSTOMIZATION_POSITIONS.LEFT
};

export const CUSTOMIZATION_WIDTH = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
  MODAL: 'customization-modal', // modal already use by bootstrap
  THUMBNAIL: 'thumbnail'
};

export const CUSTOMIZATION_MAXLENGTH = {
  INPUT: 30,
  TEXTAREA: 50
};
